import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalController, NavController } from '@ionic/angular';
import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';
import { Paginated, PaginationParams } from '@wlp/ui-bs-parameter';
import { SplitService } from '@wlp/ui-bs-split';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { SplitDto, StatusSplitEnum, TypeCodeEnum } from '@wlp/ui-px-split';
import * as moment from 'moment';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
@Component({
  selector: 'split-management',
  templateUrl: './split-management.page.html',
  styleUrls: ['./split-management.page.scss'],
})
export class SplitManagementPage implements OnInit {
  @ViewChild(`btnListDate`, { static: false }) public btnListDate: ElementRef;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  private userProfile: UserInfoProfile;

  public rangeDateFilter: FormGroup;
  public filterDays = 7;
  public searchText: string;

  public splitsPaginated: Paginated<SplitDto[]>;
  public itemsPerPageOptions: number[] = [10, 20, 30, 50, 100];
  public itemsPerPage: number = 10;
  public iconSkipLast = './assets/icon/icon-material-skip-last.svg';
  public iconNavigateLast = './assets/icon/icon-material-navigate-last.svg';
  public iconNavigateNext = './assets/icon/icon-material-navigate-next.svg';
  public iconSkipNext = './assets/icon/icon-material-skip-next.svg';
  public summaryCards = [
    {
      cardIcon: 'checkmark-circle-outline',
      cardBg: 'bg-light-primary',
      cardInfo: 0,
      cardTitle: 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.SUMMARY_CARDS.RECEIVED.TITLE',
      cardColor: 'white',
      splitLength: 0,
      status: 'SPLIT_RECEIVED',
    },
    {
      cardIcon: 'checkmark-circle-outline',
      cardBg: 'bg-light-gray',
      cardInfo: 0,
      cardTitle: 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.SUMMARY_CARDS.COMMISSIONS.TITLE',
      cardColor: 'white',
      splitLength: 0,
      status: 'SPLIT_COMMISSIONS',
    },
    {
      cardIcon: 'checkmark-circle-outline',
      cardBg: 'bg-light-success',
      cardInfo: 0,
      cardTitle: 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.SUMMARY_CARDS.NET.TITLE',
      cardColor: 'white',
      splitLength: 0,
      status: 'SPLIT_NET',
    },
  ];
  public lotStatusOptions = Object.keys(StatusSplitEnum)
    .filter(option =>
      option === StatusSplitEnum.CREATED ||
      option === StatusSplitEnum.IN_PROCESS ||
      option === StatusSplitEnum.PROCESS_COMPLETED
    )
    .map(option => ({
      key: option,
      label: `SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.${option}`
    }));
  public statusSelected: StatusSplitEnum = null;
  public typeCode: TypeCodeEnum = TypeCodeEnum.BOALI;

  constructor(
    private layoutConfigService: LayoutConfigService,
    public loadingService: LoadingService,
    private translate: UiBsTranslateService,
    protected userInfoService: UserInfoService,
    public modalController: ModalController,
    private formBuilder: FormBuilder,
    public navCtrl: NavController,
    public cdr: ChangeDetectorRef,
    public splitService: SplitService,
  ) { }

  public async ngOnInit() {
    this.initializeLayoutConfig();
    this.createRangeFilterForm();

    try {
      await this.loadInitialData();
    } catch (e) {
      console.error('Failed to load page', e);
    }
  }

  private initializeLayoutConfig() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
  }

  get today() {
    return moment().clone();
  }

  private async loadUser() {
    try {
      this.userProfile = await this.userInfoService.getInfoProfile();
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  private async loadInitialData() {
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const paginationParams = new PaginationParams(1, this.itemsPerPage);
    await this.loadUser();
    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

  public filterByStatus(status: string) {
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    switch (status) {
      case 'SPLIT_CREATE':
      case 'CREATED':
        this.statusSelected = StatusSplitEnum.CREATED;
        break;
      case 'IN_PROCESS':
        this.statusSelected = StatusSplitEnum.IN_PROCESS;
        break;
      case 'SPLIT_PROCESS_COMPLETED':
      case 'PROCESS_COMPLETED':
        this.statusSelected = StatusSplitEnum.PROCESS_COMPLETED;
        break;
    }

    this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, new PaginationParams(1, this.itemsPerPage));
  }

  public filterByRangeDate() {
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, new PaginationParams(1, this.itemsPerPage));
  }

  public resetBtnFilters() {
    const btnsHolder: HTMLElement = this.btnListDate.nativeElement as HTMLElement;
    const btns: NodeListOf<HTMLElement> = btnsHolder.querySelectorAll('.btn-filter');
    btns.forEach((btn) => btn.classList.remove('primary'));
  }

  public filterByDay(event: Event, amountDays: number) {
    this.rangeDateFilter.setValue({
      startDate: this.today.subtract(amountDays, 'days').format('DD/MM/YYYY'),
      endDate: moment(new Date()).format('DD/MM/YYYY'),
    });

    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const element: HTMLElement = event.target as HTMLElement;

    this.resetBtnFilters();
    element.classList.add('primary');

    this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, new PaginationParams(1, this.itemsPerPage));
  }

  public async filterByKeyword(value: string) {
    const searchText = value.trim();

    if (!searchText) {
      return;
    }

    const paginationParams = new PaginationParams(1, this.itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    this.searchText = searchText;
    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, this.searchText, this.typeCode, paginationParams);
  }

  public createRangeFilterForm() {
    const startValue = moment(new Date()).subtract(this.filterDays, "days").format("DD/MM/YYYY");
    const endValue = moment(new Date()).format("DD/MM/YYYY");

    this.rangeDateFilter = this.formBuilder.group({
      startDate: new FormControl(startValue),
      endDate: new FormControl(endValue),
    });
  }

  public applyStatusColor(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
        return 'status blue';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'status green';
      case StatusSplitEnum.IN_PROCESS:
        return 'status yellow';
      default:
        return 'status gray';
    }
  }

  public applyStatusText(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.CREATED';
      case StatusSplitEnum.IN_PROCESS:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.IN_PROCESS';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.PROCESS_COMPLETED';
      default:
        return status;
    }
  }

  public async getSplits(uuid?: string, uuidAccountPayment?: string, startDate?: string, endDate?: string, status?: StatusSplitEnum, keyword?: string, typeCode?: TypeCodeEnum, paginationParams?: PaginationParams) {
    this.loadingService.show()
    try {
      this.splitsPaginated = await this.splitService.getSplitLotsPaginatedWithFilter(
        uuid, uuidAccountPayment, startDate, endDate, status, keyword, typeCode, paginationParams
      ).toPromise();
      this.loadSumValuesByStatus();
    } catch (e) {
      console.error('Failed to load splits', e);
    } finally {
      this.loadingService.hide();
    }
  }

  public async loadSumValuesByStatus() {
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    const statusValues = await this.splitService.resumeSplitDataByTypeCode(
      null,
      this.userProfile.uuidAccount,
      startDateSelected,
      endDateSelected,
      this.statusSelected,
      this.searchText,
      this.typeCode
    ).toPromise();

    this.summaryCards.forEach(card => {
      switch (card.status) {
        case 'SPLIT_RECEIVED':
          card.cardInfo = statusValues.splitValuesTotal
          card.splitLength = statusValues.splitsCount
          break;
        case 'SPLIT_COMMISSIONS':
          card.cardInfo = statusValues.splitDiscountedTotal
          card.splitLength = statusValues.splitsCount
          break;
        case 'SPLIT_NET':
          card.cardInfo = statusValues.liquid
          card.splitLength = statusValues.splitsCount
          break;
      }
    });
  }

  public goToDetailsPage(uuidSplit: string) {
    this.navCtrl.navigateForward('split/franchisor/split-details', {
      queryParams: {
        uuidSplit: uuidSplit
      }
    });
  }

  public async handleChangeItemsPerPage(itemsPerPage: number) {
    this.itemsPerPage = itemsPerPage;
    const paginationParams = new PaginationParams(0, itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

  public async handleGoToFirstPage() {
    const paginationParams = new PaginationParams(1, this.itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

  public async handleGoToLastPage() {
    const lastPage = this.splitsPaginated ? this.splitsPaginated.pagination.totalPages : 0;
    const paginationParams = new PaginationParams(lastPage, this.itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

  public async handleGoToNextPage() {
    const next = this.splitsPaginated ? this.splitsPaginated.pagination.page + 1 : 0;
    const paginationParams = new PaginationParams(next, this.itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

  public async handleGoToPrevPage() {
    const prev = this.splitsPaginated ? this.splitsPaginated.pagination.page - 1 : 0;
    const paginationParams = new PaginationParams(prev, this.itemsPerPage);
    const startDateSelected = moment(this.rangeDateFilter.get('startDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");
    const endDateSelected = moment(this.rangeDateFilter.get('endDate').value, "DD/MM/YYYY").format("YYYY-MM-DD");

    await this.getSplits(null, this.userProfile.uuidAccount, startDateSelected, endDateSelected, this.statusSelected, null, this.typeCode, paginationParams);
  }

}
